export default "__VITE_ASSET__U2I6_xFN__"